import getApiInstance from '../common/apiInstance';
import {
  ActivityDetailsResponse,
  ActivityKind,
  ActivityPeriod,
  ActivitySummaryResponse,
} from './activityTypes';

const activityApi = getApiInstance('/activity', 'no-settings');

export const fetchActivitySummary =
  async (): Promise<ActivitySummaryResponse> => {
    const { data } =
      await activityApi.get<ActivitySummaryResponse>('/summary');
    return data;
  };

export const fetchActivityDetails = async (
  kind: ActivityKind,
  period: ActivityPeriod | 'all',
  offset = 0,
  limit = 50,
): Promise<ActivityDetailsResponse> => {
  const { data } = await activityApi.get<ActivityDetailsResponse>(
    `/${kind}/details`,
    {
      params: { period, offset, limit },
    },
  );
  return data;
};
